import { Component, forwardRef, Input } from '@angular/core';
import {
  ControlValueAccessor,
  FormGroup,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { collections } from '@shared/constants/collections';
import { AbstractFormControlComponent } from '../abstract-form-control.component';
import { MifadvisorCodeFormControl } from './mif-advisor-code-form-control';

@Component({
  standalone: false,
  selector: 'app-mif-advisor-code-form-control',
  templateUrl: './mif-advisor-code-form-control.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MifadvisorCodeFormControlComponent),
      multi: true
    }
  ]
})
export class MifadvisorCodeFormControlComponent
  extends AbstractFormControlComponent<MifadvisorCodeFormControl>
  implements ControlValueAccessor
{
  @Input() override parentForm: FormGroup = new FormGroup({});
  @Input() override formControlName: string = undefined;
  @Input() override title: string = undefined;
  faCheck: any = faCheck;
  collections = collections;
  onChange: any = (value: string) => {};
  onTouched: any = () => {};

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public writeValue(value: any): void {}

  public get readOnlyCss(): boolean {
    return this.control.readOnlyCss || false;
  }

  public get hideSuccessMark(): boolean {
    return this.control.hideSuccessMark || false;
  }
}
